import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
 Target, // For Marketing Impact
 Palette, // For Design Options
 Sparkles, // For Premium Look
 Megaphone // For Brand Promotion
} from 'lucide-react';

const ProductCategory2 = () => {
 const features = [
   {
     icon: Target,
     title: "Marketing Impact",
     description: "Designed for maximum brand visibility and impact at trade shows, events and promotional campaigns.",
     bgColor: "#FF4081" // Pink for impact
   },
   {
     icon: Palette, 
     title: "Design Freedom",
     description: "Premium printable surface perfect for vibrant logos, artwork and promotional messaging.",
     bgColor: "#FF9800" // Orange for creativity
   },
   {
     icon: Sparkles,
     title: "Premium Finish",
     description: "High-quality finishes and materials that enhance brand perception and create lasting impressions.",
     bgColor: "#FFC107" // Gold for premium
   },
   {
     icon: Megaphone,
     title: "Brand Promotion",
     description: "Ideal promotional tool for product launches, events and marketing campaigns to boost visibility.",
     bgColor: "#2196F3" // Blue for promotion
   }
 ];

 return (
   <div className="container py-5">
     <div className="text-center mb-5">
       <h2 className="main-heading display-5 fw-bold mb-3">Discover Features</h2>
       <p className="product-each-desc text-muted mx-auto" style={{ maxWidth: '700px' }}>
         High-impact promotional bags combining eye-catching design with premium quality, perfect for maximizing brand visibility and creating memorable impressions at events and marketing campaigns.
       </p>
     </div>

      <div className="row g-4">
        {features.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div className="card h-100 border-0 shadow-sm feature-card">
                <div className="text-center mt-4">
                  <div 
                    className="icon-container d-inline-flex align-items-center justify-content-center rounded-3 mb-4"
                    style={{ background: feature.bgColor }}
                  >
                    <IconComponent size={40} className="icon-img" />
                  </div>
                </div>
                
                <div className="card-body text-center">
                  <h3 className="card-title h5 mb-3">{feature.title}</h3>
                  <p className="card-text text-muted mb-4">{feature.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <style>
        {`
          .feature-card {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .feature-card::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 3px;
            background-color: #dc3545;
            transition: width 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-10px);
          }

          .feature-card:hover::after {
            width: 100%;
          }

          .icon-container {
            width: 80px;
            height: 80px;
            transition: all 0.3s ease;
          }

          .icon-img {
            color: white;
          }

          .feature-card:hover .icon-container {
            transform: scale(1.1);
          }
        `}
      </style>
    </div>
  );
};

export default ProductCategory2;